import {createSelector} from "reselect";
import {getCountry, getSettings} from "./settings-selectors";
import {getContainer} from "../ioc/IOCSetup";
import {isProductEnabled} from "../ui/navigation/MenuUtils";
import {includeMenuItemForCountry} from "../ui/navigation/DesktopTopMenu";
import {getUserCountry} from "./user-selectors";

export const getMobileMenuItems = createSelector(
    [getSettings, getUserCountry, getCountry],
    (settings,country, ipCountry)=>{
        let menu = getContainer().getSettingsService().getMenu();
        let menuItems = menu.items ? menu.items : [];
        menuItems = menuItems.filter(m => includeMenuItemForCountry(m, country, ipCountry)).filter( m => m.includeInMobileMenu && isProductEnabled(m.type, settings))
        return menuItems;
    });